const abilities = [
    {
        "term": "Acceleration",
        "definition": "An ability and a pulse discovery. Add +1d10 movement to a move action. Before moving, you may roll the Death Die and add the result to your movement for one move action this round."
    },
    {
        "term": "Acid Palms",
        "definition": "An ability. Add 1d10 strength to wound attempts when attacking with Fist & Tooth."
    },
    {
        "term": "Ageless",
        "definition": "An ability. You may hunt if you are retired. When you gain Hunt XP, you may decide not to gain it. Saviors age unnaturally and cannot use Ageless, though they are able to gain Ageless."
    },
    {
        "term": "Aggression Overload",
        "definition": "An ability and a pulse discovery. Add an attack roll to an attack. During your attack, after making your attack rolls but before drawing hit locations, you may roll the Death Die as an additional attack roll."
    },
    {
        "term": "Analyze",
        "definition": "An ability. At the start of the survivors' turn, if you are adjacent to the monster, reveal the top AI card, then place it back on top of the deck."
    },
    {
        "term": "Astute",
        "definition": "An ability. On Arrival, if possible, add an acanthus plant terrain card to the showdown."
    },
    {
        "term": "Bitter Frenzy",
        "definition": "An ability. Each showdown, the first time you suffer the frenzy brain trauma, gain 1d10 survival. You may spend survival while Frenzied."
    },
    {
        "term": "Burnt Nerves",
        "definition": "An ability. You are immune to bash."
    },
    {
        "term": "Caratosis",
        "definition": "An ability. Before making an attack roll, you may declare 'Caratosis X' in a loud, booming voice. If you do, that attack gains X automatic hits. X cannot be more than your total red affinities. When the attack ends, gain +X hunt XP. "+
                      "When you trigger Age 2, gain the Beast of Caratosis secret fighting art."
    },
    {
        "term": "Crystal Skin",
        "definition": "An ability. You ignore cursed and cannot wear armor. When you depart gain 3 to all hit locations. Suffer -2 to the result of all severe injury rolls. When you participate in Intimacy, newborns gain Crystal Skin in addition to any other roll results."
    },
    {
        "term": "Dormenatus",
        "definition": "An ability. When you suffer damage, you may declare 'Dormenatus X' in a loud, booming voice, if you do, gain X armor points to each hit location. X cannot be more than your total green affinities. "+
                      "After the damage is resolved, gain +X hunt XP. When you trigger Age 2, gain the Grace of Dormenatus secret fighting art."
    },
    {
        "term": "Explore",
        "definition": "An ability. When you roll on an investigate table, add +2 to your roll result."
    },
    {
        "term": "Fated Battle",
        "definition": "An ability. At the start of a showdown with the picked monster, gain +1 speed token."
    },
    {
        "term": "Forgettable",
        "definition": "An ability found in the Slenderman Expansion. Gain +2 permanent evasion. Forgettable survivors cannot be encouraged."
    },
    {
        "term": "Heart of the Sword",
        "definition": "An ability. If you gain a weapon proficiency during the Aftermath, gain +3 additional ranks. You cough up a hunk of your own solidified blood and gain +1 Iron strange resource. (per weapon proficiency)"
    },
    {
        "term": "Homing Instinct",
        "definition": "An ability. Add +5 to your rolls on the Run Away story event"
    },
    {
        "term": "Iridescent Hide",
        "definition": "An ability and dragon trait. Gain 1 to all hit locations for each different-colored affinity in your gear grid."
    },
    {
        "term": "Iron Will",
        "definition": "An ability. You cannot be knocked down. Reduce all knockback you suffer to knockback 1."
    },
    {
        "term": "Legendcaller",
        "definition": "An ability. Once a lifetime, on a hunt board space after Overwhelming Darkness, in place of rolling a random hunt event, use '53' as your result."
    },
    {
        "term": "Legs Locked",
        "definition": "An ability and a pulse discovery. While you have the Death Die, you stand. While you have the Death Die, you cannot be knocked down for any reason."
    },
    {
        "term": "Leyline Walker",
        "definition": "An ability. While there is no armor or accessory gear in your gear grid, gain +3 evasion."
    },
    {
        "term": "Life Exchange",
        "definition": "An ability. In the Aftermath, gain 1 additional Hunt XP. You may not wear other gear. If you trigger the White Secret story event, you cease to exist. When you retire, you cease to exist."
    },
    {
        "term": "Limb-Maker",
        "definition": "An ability. Once per settlement phase, spend 2 Endeavor to carve a prosthetic limb. Remove a survivor's dismembered injury and add 1 bone to the settlement's storage."
    },
    {
        "term": "Lucernae",
        "definition": "An ability. Before making a wound attempt, you many declare 'Lucernae X' in a loud, booming voice. If you do, that wound attempt gains X Luck. X cannot be more than your total blue affinities. "+
                      "When the attack ends, gain +X hunt XP. When you trigger Age 2, gain the Lucernae's Lantern secret fighting art."
    },
    {
        "term": "Mad Oracle",
        "definition": "An ability. Once per showdown, as a monster draws an AI, name a card. If the AI card drawn is the named card, gain +1 evasion token."
    },
    {
        "term": "Matchmaker",
        "definition": "An ability. When you are a returning survivor, once per lantern year, you may spend Endeavor to Story Event Intimacy."
    },
    {
        "term": "Metabolic Surrender",
        "definition": "An ability and a pulse discovery. Any time during the showdown, you may roll the Death Die. Gain twice that much survival. This round, ignore negative effects of permanent injuries, impairments, disorders, and negative attributes (including tokens). "+
                      "At the end of the round, you die."
    },
    {
        "term": "Metal Maw",
        "definition": "An ability. Your Fist & Tooth attacks gain Sharp (add 1d10 strength to each wound attempt)."
    },
    {
        "term": "Nightmare Blood",
        "definition": "An ability. Whenever you gain a bleeding token, add 1 to all hit locations."
    },
    {
        "term": "Nightmare Membrane",
        "definition": "An ability. You may spend Movement Activation to exchange any 1 of your tokens for a +1 strength token."
    },
    {
        "term": "Nightmare Spurs",
        "definition": "An ability. Once per showdown, you may spend all of your survival (at least 1) to lose all your +1 strength tokens and gain that many +1 luck tokens."
    },
    {
        "term": "Oracle's Eye",
        "definition": "An ability and a dragon trait. At the start of the showdown, look through the AI deck, then shuffle it."
    },
    {
        "term": "Partner",
        "definition": "An ability. When you gain this ability, add the name of your partner. Partners may only nominate each other for Story Event Intimacy. When you partner dies, gain a random disorder and lose this ability."
    },
    {
        "term": "Peerless",
        "definition": "An ability. When you gain insanity, you may gain an equal amount of survival."
    },
    {
        "term": "Possessed",
        "definition": "An ability. The survivor cannot use weapon specialization, weapon mastery, or fighting arts."
    },
    {
        "term": "Prepared",
        "definition": "An ability. When rolling to determine a straggler, add your hunt experience to your roll result."
    },
    {
        "term": "Presage",
        "definition": "An ability. Each time you attack, before drawing hit locations, loudly say a name. You lightly bite the eye in your cheek to see what it sees. If you draw any hit locations with the name, gain +3 insanity and +10 strength when attempting to wound them."
    },
    {
        "term": "Pristine",
        "definition": "An ability and a dragon trait. When you suffer a dismembered severe injury, ignore it and gain 1 bleeding token instead."
    },
    {
        "term": "Psychovore",
        "definition": "An ability. Once per showdown, you may eat an adjacent survior's disorder. If you do, remove the disorder. They gain 1 bleeding token and you gain +1 permanent strength. At the end of the showdown, if you haven't eaten a disorder, you die."
    },
    {
        "term": "Reflection",
        "definition": "An ability. Your complete affinities and incomplete affinity halves count as all colors. You may dodge at any time and as many times as you like each round. When you attack from a blind spot, add +1d10 to all wound attempts for that attack."
    },
    {
        "term": "Refraction",
        "definition": "An ability. Your complete affinities and incomplete affinity halves count as all colors. During the Showdown, after you perform a survival action, gain +1 survival."
    },
    {
        "term": "Rooted to All",
        "definition": "An ability. If you are standing at the start of your act, reveal the top 2 cards of the AI deck and put them back in any order."
    },
    {
        "term": "Sour Death",
        "definition": "An ability. When you are knocked down, you may encourage yourself. If you do, gain +1 strength token."
    },
    {
        "term": "Stalwart",
        "definition": "An ability. Ignore being knocked down by brain trauma and intimidate actions."
    },
    {
        "term": "Story of the Forsaker",
        "definition": "An ability. You cannot be knocked down during a showdown with a nemesis monster."
    },
    {
        "term": "Story of the Goblin",
        "definition": "An ability. Once per showdown, you may roll 1d10. On a 3+, gain the priority target token and the monster gains +1 damage token."
    },
    {
        "term": "Story of the Young Hero",
        "definition": "An ability. At the start of each of your acts, you may choose to gain 1 survival and 2 bleeding tokens."
    },
    {
        "term": "Super Hair",
        "definition": "An ability. You may spend Activation to freely exchange any tokens with adjacent survivors who have Super Hair."
    },
    {
        "term": "Sweet Battle",
        "definition": "An ability. You may surge without spending survival. If you do, the must be used to activate a weapon. You may use Sweet Battle even if your settlement cannot normally Surge. "+
                      "You may also use Sweet Battle when you have no survival and/or cannot spend survival. This does not let you Surge more than once per round."
    },
    {
        "term": "Thundercaller",
        "definition": "An ability. Once a lifetime, on a hunt board space after Overwhelming Darkness, in place of rolling a random hunt event, use '100' as your result."
    },
    {
        "term": "Tinker",
        "definition": "An ability. When you are a returning survivor, gain +1 Endeavor to use this settlement phase."
    },
    {
        "term": "Twelve Fingers",
        "definition": "An ability. You cannot carry two-handed gear. On a Perfect hit, your right hand pulses. Gain +5 insanity and +1 luck for the attack. However, for each natural 1 rolled when attempting to hit, your left hand shakes. "+
                      "Suffer 5 brain damage and -1 luck for the attack."
    },
    {
        "term": "Twilight Succession",
        "definition": "An ability. If you die during the showdown and you have a Twilight Sword, nominate another survivor on the showdown board to gain the Twilight Sword and this ability."
    },
    {
        "term": "Uninhibited Rage",
        "definition": "An ability and a pulse discovery. Add +1d10 strength to a wound attempt. After a wound attempt is rolled you may roll the Death Die and add the result to the strength of your wound attempt."
    },
    {
        "term": "Way of the Rust",
        "definition": "An ability. Your bleeding tokens are also +1 evasion tokens."
    }
];


export default abilities;